

export enum FormlyValidationType {

    required = 'required',
    matDatepickerParse = 'matDatepickerParse',
    email = 'email',

}